import React from 'react';
import NeighborhoodCharts from './neighborhoodchart';

export default class CustomNeighborhoodChart extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
          graphYears: "1"
        }
        
    }
    render(){
        /* const ChartsComponent = (props) => (<NeighborhoodCharts {...props}/>); */

        const { graphYears } = this.state;
        const { City, State } = this.props;

        return(
            <div>      
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className={graphYears && graphYears === "1" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "1"})}>1 Year</div>
                        <div className={graphYears && graphYears === "2" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "2"})}>2 Years</div>
                        <div className={graphYears && graphYears === "3" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "3"})}>3 Years</div>
                        <div className={graphYears && graphYears === "5" ? "tru-tab-button tru-tab-active" : "tru-tab-button"} onClick={() => this.setState({graphYears: "5"})}>5 Years</div>                    
                    </div>
                </div>
                <div style={{marginTop:"20px", marginBottom: "30px", minHeight: "1000px"}}>
                    <NeighborhoodCharts State={State} City={City} Years={graphYears} />
                </div>
            </div>
        )
    }
}